import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar";
import Footer from "../../components/footer";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import {
  FaChevronRight,
  FaUsers,
  FaCalendarAlt,
  FaUserShield,
  FaCheckCircle,
  FaHandsHelping,
  FaImages,
  FaNewspaper,
  FaBroadcastTower,
  FaSlidersH,
  FaEnvelope,
  FaSitemap,
  FaTasks,
  FaClipboardList,
  FaChartBar,
  FaProjectDiagram,
  FaRunning,
  FaMedal,
  FaCertificate,
  FaRegFileAlt,
  FaSearch,
  FaDatabase,
  FaUniversity,
  FaTrophy,
  FaBullhorn,
  FaCampground,
} from "react-icons/fa";

const AdminDashboard = () => {
  const navigate = useNavigate();
  const { role } = useContext(AuthContext);

  const cards = useMemo(() => [
    {
      title: "Coaching Camp Management",
      link: "/admin/coaching-camp",
      roles: ["admin", "secretary"],
      icon: FaCampground,
      category: "game_operations",
      description: "Manage Coaching Camps, coaches, athletes, daily attendance, weekly reports & performance assessments.",
    },
    {
      title: "Excellence Awards Applications",
      link: "/admin/excellence-awards",
      roles: ["admin", "secretary"],
      icon: FaTrophy,
      category: "game_operations",
      description: "Review Excellence Awards candidates and configure application deadlines.",
    },
    {
      title: "Manage Players",
      link: "/admin/manage-players",
      roles: ["admin", "secretary", "district"],
      icon: FaUsers,
      category: "user_operations",
      description: "Player profiles, approvals and core records.",
    },
    {
      title: "Medalists & Participants Achievements",
      link: "/admin/medalists-achievements",
      roles: ["admin", "secretary", "district"],
      icon: FaMedal,
      category: "game_operations",
      description: "View player medals and event participation records.",
    },
    { title: "Manage Events", link: "/admin/manage-events", roles: ["admin", "secretary", "district"], icon: FaCalendarAlt, category: "game_operations", description: "Create and maintain event schedules." },
    { title: "Login Management", link: "/admin/district-registration", roles: ["admin", "secretary"], icon: FaUserShield, category: "user_operations", description: "Create and manage Admin, Secretary, District, Regular Manager and Regular Official logins." },
    { title: "Event Approvals", link: "/admin/event-registrations", roles: ["admin", "secretary", "district"], icon: FaCheckCircle, category: "game_operations", description: "Review and approve event registrations." },
    { title: "Volunteer Approvals", link: "/admin/volunteer-registrations", roles: ["admin", "secretary", "district"], icon: FaHandsHelping, category: "user_operations", description: "Validate volunteer applications." },
    { title: "Public Achievement Visibility", link: "/admin/public-achievements", roles: ["admin", "secretary"], icon: FaMedal, category: "site_operations", description: "Show or hide public achievements for selected players or all players." },
    { title: "Manage Gallery", link: "/admin/gallery", roles: ["admin", "secretary"], icon: FaImages, category: "site_operations", description: "Upload and organize media gallery." },
    { title: "Manage News Clips", link: "/admin/news-clips", roles: ["admin", "secretary"], icon: FaNewspaper, category: "site_operations", description: "Publish news highlights and stories." },
    { title: "Manage Live Social Feeds", link: "/admin/social-feeds", roles: ["admin", "secretary"], icon: FaBroadcastTower, category: "site_operations", description: "Configure live social media streams for the homepage." },
    { title: "Manage Updates & Results", link: "/admin/content-sections?page=updates_results", roles: ["admin", "secretary"], icon: FaBroadcastTower, category: "site_operations", description: "Update live feeds and result sections." },
    { title: "Manage Slider", link: "/admin/slider", roles: ["admin", "secretary"], icon: FaSlidersH, category: "site_operations", description: "Edit homepage slider banners." },
    { title: "Mail Center", link: "/admin/mail-center", roles: ["admin", "secretary"], icon: FaEnvelope, category: "site_operations", description: "Send announcements and manage workflow mail templates." },
    { title: "Manage Scrolling Tickers", link: "/admin/announcements", roles: ["admin", "secretary"], icon: FaBullhorn, category: "site_operations", description: "Manage sliding announcements shown in the header ticker." },
    { title: "OTP Settings", link: "/admin/otp-settings", roles: ["admin"], icon: FaUserShield, category: "site_operations", description: "Bypass or require OTP verification for registration, password changes, etc." },
    { title: "Manage Website Sections", link: "/admin/content-sections", roles: ["admin", "secretary"], icon: FaSitemap, category: "site_operations", description: "Maintain structured page content." },
    { title: "Committee Members", link: "/admin/committee-members", roles: ["admin", "secretary"], icon: FaUsers, category: "site_operations", description: "Manage About committee member profiles and photos." },
    { title: "MYAS Disclosure", link: "/admin/public-documents", roles: ["admin", "secretary"], icon: FaRegFileAlt, category: "site_operations", description: "Upload, edit, publish or delete disclosure documents." },
    { title: "Eligibility Management", link: "/admin/eligibility", roles: ["admin", "secretary"], icon: FaTasks, category: "game_operations", description: "Configure and review eligibility rules." },
    { title: "Score Sheet Rules", link: "/admin/score-sheet-rules", roles: ["admin", "secretary"], icon: FaClipboardList, category: "game_operations", description: "Define score-sheet calculation logic." },
    { title: "Reports", link: "/admin/reports", roles: ["admin", "secretary"], icon: FaChartBar, category: "game_operations", description: "View exports and summary analytics." },
    { title: "Classification Allotment", link: "/admin/classification-allotment", roles: ["admin", "secretary", "district"], icon: FaProjectDiagram, category: "game_operations", description: "Assign classifications to players." },
    { title: "Games Operations Hub", link: "/admin/games-hub", roles: ["admin", "secretary", "district"], icon: FaRunning, category: "game_operations", description: "Unified desk for check-in, setups, scoring sheets, and leaderboards." },
    { title: "Player Achievements", link: "/admin/player-achievements", roles: ["admin", "secretary", "district"], icon: FaMedal, category: "game_operations", description: "Record medals and achievements." },
    { title: "Certificates Management", link: "/admin/certificates", roles: ["admin", "secretary", "district"], icon: FaCertificate, category: "game_operations", description: "Generate and manage certificates." },
    { title: "Issued Certificates", link: "/admin/certificates/issued", roles: ["admin", "secretary", "district"], icon: FaRegFileAlt, category: "game_operations", description: "Track issued certificate history." },
    { title: "Database Administration", link: "/admin/database-queries", roles: ["admin"], icon: FaDatabase, category: "site_operations", description: "Read database results or run controlled INSERT, UPDATE, and DELETE statements." },
    { title: "Bank Account Details", link: "/admin/bank-settings", roles: ["admin", "secretary"], icon: FaUniversity, category: "site_operations", description: "Edit Association bank coordinates for paid registration transfers." },
  ], []);
  const accentThemes = [
    {
      header: "from-blue-500 to-cyan-500",
      badge: "bg-blue-50 text-blue-700 border-blue-200",
      hover: "hover:shadow-blue-100",
    },
    {
      header: "from-emerald-500 to-teal-500",
      badge: "bg-emerald-50 text-emerald-700 border-emerald-200",
      hover: "hover:shadow-emerald-100",
    },
    {
      header: "from-amber-500 to-orange-500",
      badge: "bg-amber-50 text-amber-700 border-amber-200",
      hover: "hover:shadow-amber-100",
    },
    {
      header: "from-rose-500 to-pink-500",
      badge: "bg-rose-50 text-rose-700 border-rose-200",
      hover: "hover:shadow-rose-100",
    },
  ];

  const normalizedRole = (role || "").toLowerCase();
  const prefix = normalizedRole === "district" ? "/district" : "/admin";
  const visibleCards = useMemo(() => {
    return cards
      .filter((c) => c.roles.includes(normalizedRole))
      .map((c) => ({
        ...c,
        link: c.link.startsWith("/admin") ? c.link.replace("/admin", prefix) : c.link,
      }));
  }, [normalizedRole, cards, prefix]);
  const [activeTab, setActiveTab] = useState("summary");
  const [searchQuery, setSearchQuery] = useState("");
  const roleLabel =
    normalizedRole === "admin"
      ? "Administrator"
      : normalizedRole === "secretary"
      ? "Secretary"
      : normalizedRole === "district"
      ? "District"
      : "User";
  const tabs = [
    { key: "summary", label: "Summary" },
    { key: "site_operations", label: "Site Operations" },
    { key: "game_operations", label: "Game Operations" },
    { key: "user_operations", label: "User Operations" },
  ];
  const tabCards = useMemo(() => {
    if (activeTab === "summary") return visibleCards;
    return visibleCards.filter((card) => card.category === activeTab);
  }, [activeTab, visibleCards]);
  const filteredTabCards = useMemo(() => {
    const q = searchQuery.trim().toLowerCase();
    if (!q) return tabCards;
    return tabCards.filter((card) =>
      `${card.title} ${card.description || ""} ${card.category || ""}`
        .toLowerCase()
        .includes(q)
    );
  }, [tabCards, searchQuery]);
  const counts = useMemo(
    () => ({
      all: visibleCards.length,
      site_operations: visibleCards.filter((c) => c.category === "site_operations").length,
      game_operations: visibleCards.filter((c) => c.category === "game_operations").length,
      user_operations: visibleCards.filter((c) => c.category === "user_operations").length,
    }),
    [visibleCards]
  );

  const onCardKeyDown = (event, link) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      navigate(link);
    }
  };

  return (
    <>
      <Navbar />
      <div className="relative min-h-screen bg-slate-100 mobile-page-pad overflow-hidden">
        <div className="pointer-events-none absolute -top-24 -right-16 h-72 w-72 rounded-full bg-cyan-300/35 blur-3xl hidden sm:block" />
        <div className="pointer-events-none absolute top-40 -left-20 h-72 w-72 rounded-full bg-amber-300/30 blur-3xl hidden sm:block" />
        <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(to_right,rgba(148,163,184,0.08)_1px,transparent_1px),linear-gradient(to_bottom,rgba(148,163,184,0.08)_1px,transparent_1px)] bg-[size:28px_28px] hidden sm:block" />
        <div className="relative max-w-[1200px] mx-auto">
          <div className="px-2 sm:px-5 lg:px-6 py-2 sm:py-6">
            <section className="bg-white/85 backdrop-blur rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
              <div className="border-b border-slate-200 px-3 sm:px-4 py-2.5 sm:py-3 flex flex-wrap items-center justify-between gap-2">
                <div>
                  <h1 className="text-base sm:text-xl font-semibold tracking-tight text-slate-900">Admin Engagement</h1>
                  <p className="text-xs sm:text-sm text-slate-500 mt-0.5">{roleLabel} workspace with quick actions</p>
                </div>
              </div>

              <div className="border-b border-slate-200 px-2 sm:px-3 overflow-x-auto">
                <div className="flex min-w-max py-1">
                  {tabs.map((tab) => {
                    const active = tab.key === activeTab;
                    return (
                      <button
                        key={tab.key}
                        type="button"
                        onClick={() => setActiveTab(tab.key)}
                        className={`px-2.5 sm:px-3 py-1 sm:py-1.5 text-[11px] sm:text-xs font-semibold rounded-full border transition-all mr-1.5 ${
                          active
                            ? "border-cyan-200 text-cyan-800 bg-cyan-50 shadow-sm"
                            : "border-transparent text-slate-600 hover:text-slate-900 hover:border-slate-300"
                        }`}
                      >
                        {tab.label}
                      </button>
                    );
                  })}
                </div>
              </div>
              <div className="border-b border-slate-200 px-2.5 sm:px-3.5 py-2">
                <div className="relative">
                  <FaSearch className="absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-400" size={12} />
                  <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Search module..."
                    className="w-full h-8 sm:h-9 rounded-md border border-slate-300 bg-white pl-8 pr-2.5 text-xs sm:text-sm text-slate-700 focus:outline-none focus:ring-2 focus:ring-cyan-500"
                  />
                </div>
              </div>

              <div className="p-2.5 sm:p-3.5">
                <div className="hidden sm:grid grid-cols-2 lg:grid-cols-4 gap-2 mb-3">
                  <div className="rounded-lg border border-cyan-100 bg-cyan-50/80 px-3 py-2.5">
                    <p className="text-xs font-semibold text-cyan-800 uppercase tracking-wide">All Modules</p>
                    <p className="text-xl font-semibold text-slate-900 mt-0.5">{counts.all}</p>
                  </div>
                  <div className="rounded-lg border border-emerald-100 bg-emerald-50/80 px-3 py-2.5">
                    <p className="text-xs font-semibold text-emerald-800 uppercase tracking-wide">Site Operations</p>
                    <p className="text-xl font-semibold text-slate-900 mt-0.5">{counts.site_operations}</p>
                  </div>
                  <div className="rounded-lg border border-amber-100 bg-amber-50/80 px-3 py-2.5">
                    <p className="text-xs font-semibold text-amber-800 uppercase tracking-wide">Game Operations</p>
                    <p className="text-xl font-semibold text-slate-900 mt-0.5">{counts.game_operations}</p>
                  </div>
                  <div className="rounded-lg border border-rose-100 bg-rose-50/80 px-3 py-2.5">
                    <p className="text-xs font-semibold text-rose-800 uppercase tracking-wide">User Operations</p>
                    <p className="text-xl font-semibold text-slate-900 mt-0.5">{counts.user_operations}</p>
                  </div>
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-2">
                  {filteredTabCards.map((item, idx) => {
                    const theme = accentThemes[idx % accentThemes.length];
                    const Icon = item.icon;
                    return (
                      <div
                        key={item.title}
                        role="button"
                        tabIndex={0}
                        onClick={() => navigate(item.link)}
                        onKeyDown={(event) => onCardKeyDown(event, item.link)}
                        className={`relative overflow-hidden bg-white/95 backdrop-blur border border-slate-200 rounded-md p-2 cursor-pointer hover:shadow-md hover:border-slate-300 transition-all ${theme.hover} focus:outline-none focus:ring-2 focus:ring-cyan-500`}
                      >
                        <div className={`absolute -right-6 -top-6 h-10 w-10 rounded-full bg-gradient-to-br ${theme.header} opacity-15`} />
                        <div className="flex items-center justify-between">
                          <div className={`h-6 w-6 rounded-md border flex items-center justify-center ${theme.badge}`}>
                            <Icon size={11} />
                          </div>
                          <FaChevronRight className="text-slate-400" size={10} />
                        </div>
                        <h2 className="text-xs sm:text-sm font-bold text-slate-900 mt-1.5 leading-snug line-clamp-2">
                          {item.title}
                        </h2>
                        <p className="text-[11px] sm:text-xs text-slate-500 mt-0.5 line-clamp-1">
                          {item.description || "Open module"}
                        </p>
                      </div>
                    );
                  })}
                </div>
                {filteredTabCards.length === 0 ? (
                  <p className="text-xs text-slate-500 mt-3">No modules matched your search.</p>
                ) : null}
              </div>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AdminDashboard;
